"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_jss_1 = __importDefault(require("react-jss"));
const fieldTemplate_style_1 = __importDefault(require("./fieldTemplate.style"));
const fieldTypes = new Set(['string', 'boolean', 'number', 'integer', 'array']);
const Field = ({ classes, label, children, displayLabel, schema, uiSchema }) => {
    const [marginBottom, setMarginBottom] = react_1.useState(false);
    react_1.useEffect(() => {
        if (fieldTypes.has(schema.type)) {
            setMarginBottom(true);
        }
    }, [schema.type]);
    const { 'ui:widget': uiWidget } = uiSchema;
    if (uiWidget === 'hidden')
        return null;
    const hasValue = react_1.Children.toArray(children).reduce((acc, { props: { formData } }) => acc !== (typeof formData === 'undefined'), true);
    return hasValue ? (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.root, "data-is-bottom-margin": marginBottom }, { children: [false && displayLabel && (jsx_runtime_1.jsx("div", Object.assign({ className: classes.styledDiv }, { children: label }), void 0)), children] }), void 0)) : null;
};
Field.defaultProps = {
    label: null,
    displayLabel: true
};
exports.default = react_jss_1.default(fieldTemplate_style_1.default)(Field);
//# sourceMappingURL=index.js.map